import React from "react";
import PropTypes from 'prop-types';
import RemoveCircleOutlinedIcon from "@mui/icons-material/RemoveCircleOutlined";

export default function HelperText(props) {
  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <RemoveCircleOutlinedIcon style={{ fontSize: "16px" }} />
      <span style={{ paddingLeft: "5px" }}>{props.text}</span>
    </div>
  );
}

HelperText.propTypes = {
  text: PropTypes.string
};
